'use client';

import { Pagination } from '@mui/material';
import { CSSProperties } from 'react';

import { styled } from '../../styles';

export const StyledPaginationMobile = styled(Pagination)(({ theme }) => ({
  margin: theme.spacing(6, 'auto', 0),

  '& .Mui-selected': {
    color: theme.palette.info.main,
  },

  ...(theme.typography.body1 as CSSProperties),
}));
